import { createContext } from "react";

import type { ErrorHandlerContextType } from "./types.ts";

export const ErrorHandlerContext = createContext<
  ErrorHandlerContextType | undefined
>(undefined);
